import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';

export const baseURI = 'recaudacion/tipos-de-credito-pae/';

/**
 * GET Tipos de Crédito
 * param {object} params
 * @returns {Promise<object>}
 */
export const getTiposDeCredito = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tipo de Crédito
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeCredito = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Crédito
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeCredito = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Crédito
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeCredito = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Crédito
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeCredito = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
